import React from 'react';
import axios from 'axios';
import { getPunditPurohitAuthHeaders } from '../utils/auth';

const formatDate = (value) => {
  if (!value) return '';
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? '' : date.toLocaleDateString('en-US', { month: 'long', year: 'numeric' });
};

export const DevoteeTestimonials = ({ testimonials = [] }) => {
  if (!testimonials.length) return null;

  return (
    <section className="pp-testimonials" aria-label="Devotee testimonials">
      <div className="pp-testimonials-heading">
        <span>DEVOTEE EXPERIENCES</span>
        <h2>Words shared after a meaningful pooja</h2>
        <p>Real experiences from devotees who asked UC to share their feedback publicly.</p>
      </div>
      <div className="pp-testimonial-grid">
        {testimonials.map((testimonial) => (
          <article className="pp-testimonial-card" key={testimonial.id}>
            <div className="pp-testimonial-quote" aria-hidden="true">“</div>
            <p>{testimonial.testimonial}</p>
            <footer>
              <strong>{testimonial.displayName}</strong>
              {formatDate(testimonial.createdAt) && <span>{formatDate(testimonial.createdAt)}</span>}
            </footer>
          </article>
        ))}
      </div>
    </section>
  );
};

export const CustomPoojaRequest = ({ content }) => {
  if (!content) return null;
  const email = content.email || '';
  const mailto = `mailto:${email}?subject=${encodeURIComponent('Custom Pooja Request')}&body=${encodeURIComponent('Hello UC Divine Rituals Team,\n\nPooja or ritual needed:\nPreferred date and time:\nService address:\nAny other details:\n')}`;
  return (
  <section className="pp-custom-pooja" aria-label={content.heading}>
    <div>
      <span>{content.badge}</span>
      <h2>{content.heading}</h2>
      <p>{content.body}</p>
    </div>
    <a
      className="pp-custom-pooja-action"
      href={mailto}
    >
      <span>{email}</span>
      <small>{content.actionLabel}</small>
    </a>
  </section>
  );
};

export const DevoteeTestimonialForm = ({ orders = [] }) => {
  const [orderNumber, setOrderNumber] = React.useState(orders[0]?.orderId || '');
  const [testimonial, setTestimonial] = React.useState('');
  const [status, setStatus] = React.useState('');
  const [submitting, setSubmitting] = React.useState(false);

  React.useEffect(() => {
    if (!orderNumber && orders[0]?.orderId) setOrderNumber(orders[0].orderId);
  }, [orderNumber, orders]);

  if (!orders.length) return null;

  const submit = async (event) => {
    event.preventDefault();
    setSubmitting(true);
    setStatus('');
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/punditpurohit/testimonials`,
        { orderNumber, testimonial },
        { headers: getPunditPurohitAuthHeaders() }
      );
      setTestimonial('');
      setStatus(response.data?.message || 'Thank you for sharing your experience.');
    } catch (error) {
      setStatus(error?.response?.data?.message || 'Unable to submit your testimonial right now.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <section className="pp-testimonial-invitation">
      <div>
        <span>SHARE YOUR EXPERIENCE</span>
        <h2>How did your pooja feel?</h2>
        <p>A few words from you can help another devotee feel confident about planning their ritual with UC.</p>
      </div>
      <form onSubmit={submit}>
        <label>
          Booking
          <select value={orderNumber} onChange={(event) => setOrderNumber(event.target.value)} required>
            {orders.map((order) => <option key={order.orderId} value={order.orderId}>{order.orderId}</option>)}
          </select>
        </label>
        <label>
          Your testimonial
          <textarea
            value={testimonial}
            onChange={(event) => setTestimonial(event.target.value)}
            minLength="20"
            maxLength="1000"
            required
            placeholder="Please share a few words about the pooja experience..."
          />
        </label>
        <div className="pp-testimonial-form-actions">
          <small>Your feedback is reviewed by UC before it is shown publicly.</small>
          <button className="primary-btn" type="submit" disabled={submitting}>{submitting ? 'Submitting…' : 'Submit testimonial'}</button>
        </div>
        {status && <p className="pp-testimonial-status" role="status">{status}</p>}
      </form>
    </section>
  );
};
